import * as React from "react";
import { BaseMedia } from "typings/media";
import { Template, Field, FieldValues, Language   } from "typings";
import FieldEditor from "../product/FieldEditor";
import { MediaItemStyle } from "./style";
import { Button } from "office-ui-fabric-react";
export interface Props
{
    item?: BaseMedia;
    templates: {
        file: Template,
        image: Template,
        youtube: Template
    };
    updateMedia: (update: {[key: string]: any} ) => void;
    languages: Language[];
    deleteItem: () => void;
    
}

class Media extends React.Component<Props>
{
    onFieldValueChange = (key: string) => (value: FieldValues) =>
    {
        this.props.updateMedia({ [key]: value.value });
    }

    renderField = (field: Field) =>
    {
        if (this.props.item)
        {
            const value = this.props.item.data[field.field.name];
      
            return FieldEditor(field, value, this.onFieldValueChange(field.field.name), this.props.languages);
        }
       
    }

    render()
    {
       
        const { item, templates } = this.props;
        if (!item )
        {
            return <div>File not found 404</div>;
        }

        const template = (item.type === "image" ? templates.image : item.type === "file" ? templates.file : templates.youtube);
        if (!template)
        {
            return null;
        }
        return (
            <MediaItemStyle className="media-holder">
                <Button className="media-delete-button" onClick={this.props.deleteItem}>Delete</Button>
                {template.fields.map(this.renderField)}
            </MediaItemStyle>
        );
    }
}

export default Media;


// WEBPACK FOOTER //
// ./src/components/media/Media.tsx